import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { change, Field, reduxForm } from 'redux-form'
import { ButtonGroup, Button, FormGroup, Col, Label, Form } from 'reactstrap'
import Loader from '../../../common/Loader'
import VoucherTypeInputGroup from '../../../common/forms/VoucherTypeInputGroup'
import { ROAD_BOOKING_PAYMENT_TYPE } from '../../../../config/constants'
import FormFooter from '../../../common/forms/FormFooter'
import PersonInputGroup from '../../../common/forms/PersonInputGroup'
import FormItem from '../../../common/forms/FormItem'
import TextInput from '../../../common/forms/input/TextInput'
import { isRequired, validateLength } from '../../../../utils/validators'

const validatePhoneNumber = validateLength(9);

const RoadBookingPaymentForm = ({ isLoading, dispatchChange, handleSubmit, onPaymentMethodChange }) => {
  const [paymentMethod, setPaymentMethod] = useState(ROAD_BOOKING_PAYMENT_TYPE.CASH);

  const handlePaymentMethodChange = (method) => {
    setPaymentMethod(method);
    if (onPaymentMethodChange) {
      onPaymentMethodChange(method);
    }
  };

  const handlePassengerChange = (passenger) => {
    if (passenger && passenger.mobilePhone) {
      dispatchChange('roadBookingPaymentForm', 'phoneNumber', passenger.mobilePhone);
    }
  };

  if (isLoading) {
    return <Loader />
  }

  return (

    <Form onSubmit={handleSubmit}>
      <PersonInputGroup
        label="Pasajero"
        name='passenger'
        form="roadBookingPaymentForm"
        onChange={handlePassengerChange}
      />

      <FormGroup row>
        <FormItem label="Teléfono" required>
          <Field
            name="phoneNumber"
            component={TextInput}
            validate={[isRequired, validatePhoneNumber]}
            type="text"
            placeholder="Número de Teléfono"
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <Col sm={3} xs={12}>
          <Label>
            Método de pago <span className="text-danger">*</span>
          </Label>
        </Col>
        <Col sm={7} xs={12}>
          <ButtonGroup className='modal-fullscreen' size="md">
            {Object.values(ROAD_BOOKING_PAYMENT_TYPE).map((method) => (
              <Button
                key={method.value}
                color="primary"
                onClick={() => handlePaymentMethodChange(method)}
                outline
                active={paymentMethod.value === method.value}
                className='z-0'
              >
                {method.label}
              </Button>
            ))}
          </ButtonGroup>
        </Col>
      </FormGroup>

      <VoucherTypeInputGroup
        voucherTypeFieldName="voucherType"
        businessFieldName="business"
        businessTaxIdFieldName="businessTaxId"
        businessNameFieldName="businessName"
        addressSummaryFieldName="addressSummary"
        change={dispatchChange}
      />
      <FormFooter saveButtonText="Pagar" />
    </Form>
  )
}

RoadBookingPaymentForm.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onPaymentMethodChange: PropTypes.func,
  dispatchChange: PropTypes.func.isRequired,
}

RoadBookingPaymentForm.defaultProps = {
  onPaymentMethodChange: null,
}


const mapDispatchToProps = {
  dispatchChange: change
}


export default connect(null, mapDispatchToProps)(
  reduxForm({
    form: 'roadBookingPaymentForm',
  })(RoadBookingPaymentForm)
);

